// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tdrs-menu .txt:hover {
  font-size: 17px !important;
  font-weight: bold;
  line-height: 30px;
}
.tdrs-menu .header-button:hover,
.tdrs-menu .header-button:focus {
  background-color: #a60405;
  outline: none;
  font-size: 14px !important;
  font-weight: bold !important;
}
.tdrs-menu a:hover {
  text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .tdrs-menu .header-button {
    background: #cc0000;
    color: rgb(255, 255, 255) !important;
  }
  .tdrs-menu .header-button .active,
  .tdrs-menu .header-button:hover,
  .tdrs-menu .header-button:focus {
    background: transparent;
    color: rgb(14, 19, 25) !important;
  }
  .tdrs-menu .tgpp-t-logo {
    max-width: 100px;
    min-width: 100%;
  }
}
.tdrs-menu .logo-text {
  text-shadow: 2px 1px 2px #404041;
  margin: 10px 0;
  line-height: 42px;
  font-weight: 700;
  margin-top: 5px;
  font-family: Toyota-bold, sans-serif;
  font-size: 32px;
}
.tdrs-menu .tgpp-t-logo {
  width: 145px;
  float: right;
}
.tdrs-menu .links a {
  padding: 20px 0px;
  padding-bottom: 33px;
  line-height: 35px;
  margin: 0 15px;
  text-align: center;
  min-width: 7rem;
}

.tgpp-submenu {
  margin-top: 60px;
  background-color: #545353;
  color: #fff;
}
.tgpp-submenu .web-url {
  padding: 15px 25px;
  position: relative;
  text-align: right;
  width: fit-content;
  float: right;
  background: #d81820;
}
.tgpp-submenu .user-info {
  width: 100%;
  padding: 15px 0;
  position: absolute;
  background: #545353;
  max-height: 53px;
}
.tgpp-submenu .web-url:before {
  content: "";
  position: absolute;
  border-top: 53px solid #d81820;
  border-left: 55px solid transparent;
  width: 20px;
  height: 0px;
  top: 0;
  left: -54px;
  filter: drop-shadow(-13px -4px 5px rgba(54, 3, 5, 0.6196078431));
  z-index: 12;
}
.tgpp-submenu span.small-text {
  font-size: 10px;
}
.tgpp-submenu .user-info .site-desc {
  padding-left: 30px;
  display: inherit;
  line-height: 14px;
}
.tgpp-submenu .row {
  display: flex;
}
.tgpp-submenu .user-info .col-4 {
  text-align: center;
}
.tgpp-submenu .user-info .col-4 .user-name {
  line-height: 24px !important;
}
.tgpp-submenu .user-info .col-2:nth-child(3) {
  margin-left: 15%;
  text-align: right;
}
.tgpp-submenu .user-info .col-2:nth-child(3) .logout {
  line-height: 24px !important;
}

.tgpp-topmenu {
  max-height: 53px;
}

.menu-title-spacing {
  margin-left: 20px;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/menu/menu.component.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EACA,iBAAA;EACA,iBAAA;AAAJ;AAGE;;EAEE,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;AADJ;AAGE;EACE,0BAAA;AADJ;AAGE;EACE;IACE,mBAAA;IACA,oCAAA;EADJ;EAIE;;;IAGE,uBAAA;IACA,iCAAA;EAFJ;EAKE;IACE,gBAAA;IACA,eAAA;EAHJ;AACF;AAKE;EACE,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,eAAA;AAHJ;AAKE;EACE,YAAA;EACA,YAAA;AAHJ;AAKE;EACE,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAHJ;;AAMA;EACE,gBAAA;EAEA,yBAAA;EACA,WAAA;AAJF;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAJF;AAMA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAJF;AAUA;EACE,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,mCAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,gEAAA;EACA,WAAA;AARF;AAUA;EACE,eAAA;AARF;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AATF;AAWA;EACE,aAAA;AATF;AAYA;EAEE,kBAAA;AAXF;AAYE;EACE,4BAAA;AAVJ;AAcA;EACE,gBAAA;EACA,iBAAA;AAZF;AAaE;EACE,4BAAA;AAXJ;;AAgBA;EACE,gBAAA;AAbF;;AAiBA;EACE,iBAAA;EACA,eAAA;AAdF","sourcesContent":[".tdrs-menu {\n  .txt:hover {\n    font-size: 17px !important;\n    font-weight: bold;\n    line-height: 30px;\n  }\n\n  .header-button:hover,\n  .header-button:focus {\n    background-color: #a60405;\n    outline: none;\n    font-size: 14px !important;\n    font-weight: bold !important;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  @media screen and (max-width: 768px) {\n    .header-button {\n      background: #cc0000;\n      color: rgb(255, 255, 255) !important;\n    }\n\n    .header-button .active,\n    .header-button:hover,\n    .header-button:focus {\n      background: transparent;\n      color: rgb(14, 19, 25) !important;\n    }\n\n    .tgpp-t-logo {\n      max-width: 100px;\n      min-width: 100%;\n    }\n  }\n  .logo-text {\n    text-shadow: 2px 1px 2px #404041;\n    margin: 10px 0;\n    line-height: 42px;\n    font-weight: 700;\n    margin-top: 5px;\n    font-family: Toyota-bold, sans-serif;\n    font-size: 32px;\n  }\n  .tgpp-t-logo {\n    width: 145px;\n    float: right;\n  }\n  .links a {\n    padding: 20px 0px;\n    padding-bottom: 33px;\n    line-height: 35px;\n    margin: 0 15px;\n    text-align: center;\n    min-width: 7rem;\n  }\n}\n.tgpp-submenu {\n  margin-top: 60px;\n  // padding: 15px 0;\n  background-color: #545353;\n  color: #fff;\n  \n.web-url {\n  padding: 15px 25px;\n  position: relative;\n  text-align: right;\n  width: fit-content;\n  float: right;\n  background: #d81820;\n}\n.user-info {\n  width: 100%;\n  padding: 15px 0;\n  position: absolute;\n  background: #545353;\n  max-height: 53px;\n  // -webkit-box-shadow: 1px 8px 13px -10px rgba(89, 89, 89, 0.58);\n  // -moz-box-shadow: 1px 8px 13px -10px rgba(89, 89, 89, 0.58);\n  // box-shadow: 1px 8px 13px -10px rgba(89, 89, 89, 0.58);\n}\n\n.web-url:before {\n  content: \"\";\n  position: absolute;\n  border-top: 53px solid #d81820;\n  border-left: 55px solid transparent;\n  width: 20px;\n  height: 0px;\n  top: 0;\n  left: -54px;\n  filter: drop-shadow(-13px -4px 5px #3603059e);\n  z-index: 12;\n}\nspan.small-text {\n  font-size: 10px;\n}\n\n.user-info .site-desc {\n  padding-left: 30px;\n  display: inherit;\n  line-height: 14px;\n}\n.row {\n  display: flex;\n}\n\n.user-info .col-4 {\n  // margin-left: 5%;\n  text-align:center;\n  .user-name {\n    line-height: 24px !important;\n  }\n}\n\n.user-info .col-2:nth-child(3) {\n  margin-left: 15%;\n  text-align: right;\n  .logout {\n    line-height: 24px !important;\n  }\n}\n\n}\n.tgpp-topmenu{\n  max-height: 53px;\n}\n\n\n.menu-title-spacing{\n  margin-left:20px;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
